import React from 'react';
import { Icon, IconType, Tag, Theme } from '@routific/hive';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Props {
  startTimeString?: string;
  endTimeString?: string;
  rangeString?: string;
}

const TagWrapper = styled.span`
  align-self: flex-start;
`;

const StyledTag = styled(Tag)`
  background-color: ${Theme.Colors.gray4};
  padding-left: ${Theme.Spacing.xsSpacing};
`;

const OrderTimeWindow: React.FC<Props> = ({ startTimeString, endTimeString, rangeString }) => {
  const { t } = useTranslation('common');

  let label: string | undefined;
  if (startTimeString && endTimeString) {
    label = rangeString;
  } else if (startTimeString) {
    label = `${t('orderDetails.deliverBetween.after')} ${startTimeString}`;
  } else if (endTimeString) {
    label = `${t('orderDetails.deliverBetween.before')} ${endTimeString}`;
  }

  if (!label) return null;

  return (
    <TagWrapper>
      <StyledTag size="small" icon={<Icon icon={IconType.Time} />}>
        {label}
      </StyledTag>
    </TagWrapper>
  );
};

export default OrderTimeWindow;
